import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Washington.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Fueling Washington DC’s Digital Revolution: Where Innovation and
              Expertise Converge
            </h2>
            <p>
              Immerse yourself in the unparalleled expertise of TekRevol’s top
              App Developers in Washington DC. We blend exceptional skills,
              ground-breaking ideas, and top-tier coding practices to reform
              digital distinction.
            </p>
            <p>
              With a great status in the tech market, we launch businesses
              toward their objectives utilizing pioneering solutions and
              groundbreaking technology. Our commitment spreads beyond
              development, providing steadfast after sales support and secure
              cloud-based hosting for an effortless digital journey.
            </p>
            <p>
              Empowering enterprises with incorporated mobile app solutions, we
              pave the way for substantial revenue growth. Board on your digital
              transformation journey today with TekRevol and transform your
              business in the evolving digital landscape.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
